import React, { Component } from "react";
import $ from 'jquery'
import fbSocialImg from "../images/fb_social.webp"
import pinterestSocialImg from "../images/pinterest_social.webp"
import linkedinSocialImg from "../images/linkedin_social.webp"
import qrcode from "../images/frame.png"
import Parser from 'html-react-parser';
// import ReactStars from "react-rating-stars-component";
// import { Rating } from 'react-simple-star-rating'
import Rating  from 'react-star-ratings'
import Slider from "react-slick";
import AxisOnSocial from "../images/Airtel-CC-Desktop.jpg"
import AxisOnSocialMob from "../images/Airtel-CC-Mobile.jpg"
import QRCode from "react-qr-code";
import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
class LocatorBranchInfo extends Component {
  constructor(props) {
    super(props)
    this.state = {
      qrCode: "https://search.google.com/local/writereview?placeid=" + this.props.placeId,
      customHrs: ""
    }
  }
  componentDidMount() {
    this.CustomHrs();
    var showChar = 100;
    var ellipsestext = "";
    var moretext = "...more";
    var lesstext = "...less";
    $('.more').each(function () {
      var content = $(this).html();
      if (content.length > showChar) {
        var c = content.substr(0, showChar);
        var h = content.substr(showChar, content.length - showChar);
        var html = c + '<span className="moreellipses">' + ellipsestext + '&nbsp;</span><span className="morecontent"><span>' + h + '</span>&nbsp;&nbsp;<a href="#" className="morelink">' + moretext + '</a></span>';
        $(this).html(html);
      }
    });
    $(".morelink").click(function () {
      if ($(".morelink").hasClass("less")) {
        $(".morelink").removeClass("less");
        $(".morelink").html(moretext);
      } else {
        $(".morelink").addClass("less");
        $(".morelink").html(lesstext);
      }
      $(".morelink").parent().prev().toggle();
      $(".morelink").prev().toggle();
      return false;
    });
  }

  CustomHrs = () => {
    if (this.props.bussinessHrs !== "Open 24 hours") {
      const parts = this.props.bussinessHrs.split('|');
      const days = parts[1];
      const startTime = parts[2];
      const endTime = parts[3];
      this.setState({ customHrs: `${days}: ${startTime} - ${endTime}` })
    }
  }

  clearSesseion = (stateValueSet, citySet, searchValueSet) => {
    window.sessionStorage.setItem("searchObjArray", JSON.stringify([{ stateValueSet: stateValueSet }, { citySet: citySet }, { locationSet: "" }, { radiusSet: "" }, { searchCategorySet: [] }, { searchServiceSet: [] }, { offsetSet: "0" }, { activePageSet: 1 }, { searchValueSet: searchValueSet }, { currentLocationFlagSetValue: false }, { locationList: this.state.locationList }, { stateList: this.state.stateList }, { cityList: this.state.cityList }]))
  }

  render() {
    var youtubeSlider = {
      dots: false,
      infinite: false,
      speed: 200,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipe: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    };
    var offerSlider = {
      dots: false,
      infinite: false,
      speed: 200,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    var socialSlider = {
      dots: false,
      infinite: false,
      speed: 200,
      slidesToShow: 4,
      slidesToScroll: 1,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    };
    return (
      <div className="container branch-info-wrapper">
        <div className="row m-0">
          <div className="col-lg-4 col-md-12 px-0 pr-lg-1">
            <h3 className="main-head">Bank / ATM  <span>Services</span></h3>
            <div className="branch-service-main">
              {(this.props.bankservices !== undefined && this.props.bankservices !== "undefined" && this.props.bankservices !== "") ?
                <div className="branch-service-tags-main">
                  {this.props.bankservices.split("^^").map((data, i) => (
                    data !== "" ? (
                      <span key={i}>{data.split("^^")[0]}</span>
                    ) : ""
                  ))}
                </div>
                : ""}
              <div className="ratings-main">
                <div>
                  <h3 className="sub-head pt-0"> Ratings </h3>
                  <p className="style_rating d-flex">
                    <Rating
                      key={this.props.loc_ratings}
                      numberOfStars={5}
                      rating={(this.props.loc_ratings) ?? 0
                      }
                      // initialValue={((this.props.loc_ratings + "")?.split(".")[1] < 5 ?
                      //   (this.props.loc_ratings + "")?.split(".")[0] + "." + 5
                      //   :
                      //   this.props.loc_ratings) ?? 0
                      // }
                      // allowFraction={true}
                      starDimension="22px"
                      starSpacing="2px"
                      starRatedColor="#98144e"
                      name='rating'
                    />
                    {/* <ReactStars
                        count={5}
                        size={30} isHalf={true}
                        value={(this.props.loc_ratings + "").split(".")[1] < 5 ?
                          (this.props.loc_ratings + "").split(".")[0] + "." + 5
                          :
                          this.props.loc_ratings
                        }
                        emptyIcon={<i className="far fa-star"></i>}
                        halfIcon={<i className="fa fa-star-half-alt"></i>}
                        fullIcon={<i className="fa fa-star"></i>}
                        activeColor="#98144e"
                        color="#d1d1d1"
                        edit={false}
                      /> */}
                    {/* {this.props.loc_ratings > 0 && */}
                    {/* <span className="start-textloactr">{this.props.loc_ratings}</span> */}
                    {/* } */}
                  </p>
                  {this.props.placeId != "" &&
                    <a href={"https://search.google.com/local/writereview?placeid=" + this.props.placeId} target={"_blank"}>
                      <button className="sub-review" title="Submit your review on our Google Plus page">Submit a Review </button>
                    </a>
                  }

                </div>
                {this.props.placeId != "" &&
                  <div className="qrcode">
                    {/* <img src={qrcode} alt="QR Code" width="140px" height="140px"/> */}
                    <a href={this.state.qrCode} target={"_blank"}>
                      <QRCode
                        size={256}
                        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                        value={this.state.qrCode}
                        viewBox={`0 0 256 256`}
                      />
                    </a>
                  </div>
                }
              </div>

              {this.props.bussinessHrs !== "" &&
                <div className="businesshrs-main">
                  <h3 className="sub-head">Business Hours</h3>
                  {/* {this.props.bussinessHrs !== "" &&
                    <p>{this.props.bussinessHrs} </p> 
                  } */}
                  {this.props.bussinessHrs !== "Open 24 hours" ? <>
                    <p>{this.state.customHrs} </p>
                    <p className="business-content">  The branch will remain closed on the 2nd and 4th Saturday of every month. </p>
                  </>
                    :
                    <p>{this.props.bussinessHrs} </p>
                  }
                </div>
              }
            </div>
          </div>
          <div className="col-lg-4 col-md-6 bank-data-main">
            <h3 className="main-head">
              {this.props.timing.split('|||')[0].split(' ')[0] + " "}
              {this.props.timing.split('|||')[0].split(' ')[1] &&
                <span>{this.props.timing.split('|||')[0].slice(this.props.timing.split('|||')[0].indexOf(' '))}</span>
              }
            </h3>
            <img alt="Calculate" title="Calculate ease" src={this.props.cdnPath + "production/" + this.props.timing.split('|||')[1]} className="img-fluid" width="360" height="183"></img>
            <ul className="bank-data-ul">
              {this.props.timing.split('|||')[1] !== undefined ? <>
                {this.props.timing.split('|||')[2].split('^^').map((data, i) => (
                  data !== "" ? (
                    <li className="bank-data-li" key={i}>
                      <a href={data.split(",,")[1]} target="_blank" rel="noopener noreferrer">{data.split(",,")[0]}</a>
                    </li>
                  ) : ""
                ))}
              </> :
                ""
              }
              {this.props.timing.split('|||')[3] !== undefined ? <>
                <>
                  {this.props.timing.split('|||')[2] !== "" ? (
                    <li className="bank-data-li">
                      <a href={this.props.timing.split('|||')[3].split(',,')[1]} target="_blank" rel="noopener noreferrer">{this.props.timing.split('|||')[3].split(',,')[0]}</a>
                    </li>
                  ) : ""}
                </>
              </> :
                ""
              }
            </ul>
          </div>
          <div className="col-lg-4 col-md-6 progressBlog">
            <h3 className="main-head">
              {this.props.progressBlog.split("|||")[0].split("|")[0].split(' ').length !== 1 ?
                <>
                  {this.props.progressBlog.split("|||")[0].split("|")[0].substring(0, this.props.progressBlog.split("|||")[0].split("|")[0].lastIndexOf(' '))}
                  <span>{this.props.progressBlog.split("|||")[0].split("|")[0].slice(this.props.progressBlog.split("|||")[0].split("|")[0].lastIndexOf(' '))}</span>
                </>
                :
                this.props.progressBlog.split("|||")[0].split("|")[0]
              }
            </h3>
            <img alt={this.props.progressBlog.split("|||")[0].split("|")[1]} src={this.props.cdnPath + "production/" + this.props.progressBlog.split("|||")[1]} className="img-fluid" width="360" height="183"></img>
            <h4 className="sub-head-18 ps-2">{this.props.progressBlog.split("|||")[0].split("|")[1]}</h4>
            <p className="mb-1 ps-2">{this.props.progressBlog.split("|||")[0].split("|")[2]}</p>
            <ul className="bank-data-blog ps-2">
              {this.props.progressBlog.split("|||")[3] !== undefined ? <>
                <li className="bank-data-readmore">
                  <a className="bank-data-readmoreLink" href={this.props.progressBlog.split("|||")[3].split(',,')[1]} target="_blank" rel="noopener noreferrer">{this.props.progressBlog.split("|||")[3].split(',,')[0]}</a>
                  <span className="read-time">5 min read</span>
                </li>
              </> :
                ""
              }
              {this.props.progressBlog.split("|||")[4] !== undefined ? <>
                <li className="bank-data-blog-li">
                  <a href={this.props.progressBlog.split("|||")[4].split(',,')[1]} target="_blank" rel="noopener noreferrer">{this.props.progressBlog.split("|||")[4].split(',,')[0]}</a>
                </li>
              </> :
                ""
              }
            </ul>
          </div>
        </div>

        <div className="row mt-4 m-0">
          <div className="col-lg-8 col-md-12 px-0 ytube_slider">
            <h2 className="main-head">Youtube <span>Videos</span></h2>
            <Slider {...youtubeSlider}>

              {this.props.youtubeVideos !== "null" ? (
                this.props.youtubeVideos.split("^^").map((data, i) => (
                  data !== "" ? (
                    <div className="pe-3 ps-lg-1 position-relative" key={i}>
                      {/* <img src={axisCalculatorImg} className="img-fluid"></img> */}
                      <a href={data.split(',,')[1]} target="_blank" rel="noopener noreferrer" className="position-relative d-flex">
                        <img data-src={this.props.cdnPath + "production/" + data.split(',,')[2]} className="img-fluid youtube_img lazyload" alt={data.split(',,')[0]} width="223" height="125"></img>
                        <span className="yt-play-icon"></span>
                        {/* <ReactPlayer
                          url={data.split(',,')[1]}
                          //alt={eventObjects.altText}
                          width='100%'
                          height='100%'
                          className="youtube-link-img"
                        /> */}
                      </a>
                      <a href={data.split(',,')[1]} className="youTube-link" target="_blank" rel="noopener noreferrer">
                        {data.split(',,')[0]}
                      </a>
                    </div>
                  ) : ""
                ))
              ) : ""}
            </Slider>
          </div>
          <div className="col-lg-4 col-md-6 px-0 ps-lg-4">
            <h2 className="main-head">
              {this.props.offers.split("|||")[0].split(' ')[0] + " "}
              {this.props.offers.split('|||')[0].split(' ')[1] &&
                <span>{this.props.offers.split('|||')[0].slice(this.props.offers.split('|||')[0].indexOf(' '))}</span>
              }
            </h2>
            <Slider {...offerSlider}>
              <div className="px-0">
                {this.props.offers && (
                  this.props.offers.split("|||")[2] !== "" ?
                    <a href={this.props.offers.split("|||")[2]} target="_blank" rel="noopener noreferrer">
                      <img data-src={this.props.cdnPath + "production/" + this.props.offers.split("|||")[1]} className="img-fluid offer_img lazyload" width="330" height="277" alt="Digital Current Account" title="Digital Current Account"></img>
                    </a>
                    :
                    <a href={"https://maximus.axisbank.co.in/external/customer/login?product=credit_card&channelName=VENDOR&channelCode=WEBSITE&utm_content=branchbanking&utm_campaign=website&cta=branch-banking-myzone-banner-second"} target="_blank" rel="noopener noreferrer">
                      <img data-src={this.props.cdnPath + "production/" + this.props.offers.split("|||")[1]} className="img-fluid offer_img lazyload" width="330" height="277" alt="Digital Current Account" title="Digital Current Account"></img>
                    </a>
                )
                }
              </div>
            </Slider>
          </div>
        </div>
        <div className="row mt-4 m-0">
          <div className="col-md-12 p-0">
            <h3 className="main-head">Axis On <span>Social</span></h3>
            <img src={AxisOnSocial} className="img-fluid axisonsocial_web" width="100" height="100" />
            <img src={AxisOnSocialMob} className="img-fluid axisonsocial_mob" width="100" height="100" />
            {/* <Slider {...socialSlider}>
              <div className="px-2 axis_social_more">
                <p className="more" title="Here are India s most valuable unlisted companies. Read the report today at https t.co M1kMTgrYUu. HurunIndia https t.co eKLWa2iFPQ">Here are India s most valuable unlisted companies. Read the report today at https t.co M1kMTgrYUu. HurunIndia https t.co eKLWa2iFPQ</p>
                <p>Posted on : 30 Sep 2022</p>
                <div className="socials-share-main">
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={fbSocialImg} alt="facebook" width="10" height="18" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={pinterestSocialImg} alt="pinterest" width="15" height="19" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={linkedinSocialImg} alt="linkedin" width="20" height="19" className="lazyload"></img>
                    </a>
                  </div>
                </div>
              </div>
              <div className="px-2 axis_social_more">
                <p className="more" title="Its the wildlife that adds thrills to our travel experiences. This World Wildlife Conservation Day, lets take a p https t.co VHQ2xhttwz">Its the wildlife that adds thrills to our travel experiences. This World Wildlife Conservation Day, lets take a p https t.co VHQ2xhttwz</p>
                <p>Posted on : 30 Sep 2022</p>
                <div className="socials-share-main">
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={fbSocialImg} alt="facebook" width="10" height="18" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={pinterestSocialImg} alt="pinterest" width="15" height="19" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={linkedinSocialImg} alt="linkedin" width="20" height="19" className="lazyload"></img>
                    </a>
                  </div>
                </div>
              </div>
              <div className="px-2 axis_social_more">
                <p className="more" title="She is a working mother whose commitments extend beyond the confines of her home, how will she manage both Keep wa https t.co ZpKcrJQL45">She is a working mother whose commitments extend beyond the confines of her home, how will she manage both Keep wa https t.co ZpKcrJQL45</p>
                <p>Posted on : 30 Sep 2022</p>
                <div className="socials-share-main">
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={fbSocialImg} alt="facebook" width="10" height="18" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={pinterestSocialImg} alt="pinterest" width="15" height="19" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={linkedinSocialImg} alt="linkedin" width="20" height="19" className="lazyload"></img>
                    </a>
                  </div>
                </div>
              </div>
              <div className="px-2 axis_social_more">
                <p className="more" title="Lets celebrate the fearless and selfless warriors in white AxisBank IndianNavyDay MenInWhite SeaSoldiers https t.co b9mflSe71j">Lets celebrate the fearless and selfless warriors in white AxisBank IndianNavyDay MenInWhite SeaSoldiers https t.co b9mflSe71j</p>
                <p>Posted on : 30 Sep 2022</p>
                <div className="socials-share-main">
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={fbSocialImg} alt="facebook" width="10" height="18" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={pinterestSocialImg} alt="pinterest" width="15" height="19" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={linkedinSocialImg} alt="linkedin" width="20" height="19" className="lazyload"></img>
                    </a>
                  </div>
                </div>
              </div>
              <div className="px-2 axis_social_more">
                <p className="more">Vishers are out there to get your money. Axis Bank employees will never call you and ask you for you r personal bank… https://t.co/XS4sj3nKQu </p>
                <p>Posted on : 30 Sep 2022</p>
                <div className="socials-share-main">
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={fbSocialImg} alt="facebook" width="10" height="18" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={pinterestSocialImg} alt="pinterest" width="15" height="19" className="lazyload"></img>
                    </a>
                  </div>
                  <div className="socials-share-list">
                    <a href="#" target="_blank" rel="noopener noreferrer">
                      <img src={linkedinSocialImg} alt="linkedin" width="20" height="19" className="lazyload"></img>
                    </a>
                  </div>
                </div>
              </div>
            </Slider> */}
          </div>
        </div>
        <div className="row mt-4 m-0">
          <div className="col-md-12 about-section p-0">
            <h3 className="main-head">
              {this.props.about.split("|||")[0].split(' ')[0] + " "}
              {this.props.about.split('|||')[0].split(' ')[1] &&
                <span>{this.props.about.split('|||')[0].slice(this.props.about.split('|||')[0].indexOf(' '))}</span>
              }
            </h3>
            <p className="mb-0">{this.props.about.split("|||")[1]}</p>
            {this.props.address != "" ?
              <p>The address of this branch/ATM is
                <span className="about-section_subpara">
                  {((this.props.branchInfoDetails.split("|")[7].includes("ATM")) || (this.props.branchInfoDetails.split("|")[7].includes("Branch"))) ?
                    " " + this.props.address
                    :
                    " " + this.props.address + ", " + this.props.City + ", " + this.props.State + " - " + this.props.pinCode
                  }
                </span></p>
              : ""}
          </div>
        </div>
        <div className="row mt-3 m-0">
          <div className="col-lg-4 col-md-12 px-0 branches-category-main">
            <div className="bank-otherStores">
              <h3 className="sub-head-18">{this.props.servicesOptions.split("|||")[0]}</h3>
              <ul className="bank-otherStore-ul">
                {/* {this.props.servicesOptions.split("|||")[2] !== undefined ? <>
                  {this.props.servicesOptions.split("|||")[2].split("^^").map((data, index) => (
                    <>
                      {data !== "" ? (
                        <li className="bank-otherStore-li">
                          <span>{this.props.servicesOptions.split("|||")[1]}</span>
                          <a href={data.split(",,")[1]} target="_blank" rel="noopener noreferrer">{data.split(",,")[0]}</a>
                        </li>
                      ) : ""}
                    </>
                  ))}
                </> : */}
                <>
                  <li className="bank-otherStore-li">AXIS BANK Branches/ATMs in <a href={"/location/" + this.props.State.replaceAll(" ", "-").toLowerCase()} onClick={() => this.clearSesseion(this.props.State, "", "")}>{this.props.State}</a></li>
                  <li className="bank-otherStore-li">AXIS BANK Branches/ATMs in <a href={"/location/" + this.props.State.replaceAll(" ", "-").toLowerCase() + "/" + this.props.City.replaceAll(" ", "-").toLowerCase()} onClick={() => this.clearSesseion(this.props.State, this.props.City, "")}>{this.props.City}</a></li>
                </>
                {/* } */}
              </ul>
            </div>
            {(this.props.fuelAvailable.split('|||')[1] !== (undefined || "undefined")) &&
              <div className="bank-category">
                <h3 className="sub-head-18">{this.props.fuelAvailable.split("|||")[0]}</h3>
                <ul className="bank-category-ul">
                  {this.props.fuelAvailable.split("|||")[1].split("^^").map((data, i) => (
                    data !== "" ? (
                      <li className="bank-category-li" key={i}>
                        <span>{data.split("^^")[0].replaceAll("&amp;", "&")}</span>
                      </li>
                    ) : ""
                  ))}
                </ul>
              </div>
            }
          </div>
          {/* {console.log("this.props.paymentMethod =",this.props.address)} */}
          {/* {this.props.paymentMethod.split("|||")[1] !== undefined && this.props.paymentMethod.split("|||")[1] !== "" ? */}
          <>
            <div className="col-lg-4 col-md-12 px-0 ps-lg-3 nearByLocal">
              {/* {this.props.address.split(",")[2] != "" && this.props.address.split(",")[2] != undefined ?
                <>
                  <h3 className="sub-head-18">{this.props.paymentMethod.split("|||")[0]}</h3>
                  <ul className="near-by-localities">
                    <li className="near-by-localities-li"><a href={"/?search="+this.props.address.split(",")[2].trim().replaceAll(" ","+")+" +"+this.props.City.replaceAll(" ","-")+ " +" + this.props.branchInfoDetails.split("|")[6]} onClick={() => this.clearSesseion("", "", this.props.address.split(",")[2] + ", " + this.props.City + ", " + this.props.branchInfoDetails.split("|")[6])} >{this.props.address.split(",")[2]}</a></li>
                  </ul>
                </>
                : ""} */}
              {this.props.getNearLocality.length > 0 ?
                <>
                  <h3 className="sub-head-18">{this.props.paymentMethod.split("|||")[0]}</h3>
                  <ul className="near-by-localities">
                    {this.props.getNearLocality.map((data, i) => (
                      <li className="near-by-localities-li" key={i}>
                        <a href={"/?search=" + data.location.trim().replaceAll(" ", "+") + " +" + data.city_name.replaceAll(" ", "+") + " +" + data.pin_code} onClick={() => this.clearSesseion("", "", data.location + ", " + data.city_name + ", " + data.content_section_2.split("|")[6])} >
                          {data.location}
                        </a>
                      </li>
                    ))
                    }
                  </ul>
                </>
                : ""}
            </div>
          </>
          {/* :
            ""
          } */}
        </div>
        <div className="row m-0 mt-md-4 parking_tag_payment_axis">
          <div className="col-lg-8 col-md-12 parking-payment-main">
            {(this.props.parkingOptions.split("|||")[1] !== (undefined || "undefined")) &&
              <div className="parking-option-main">
                <h3 className="sub-head-18">{this.props?.parkingOptions?.split("|||")[0]}</h3>
                <ul className="parking-option-ul">
                  {this.props?.parkingOptions?.split("|||")[1]?.split("^^")?.map((data, i) => (
                    data !== "" ? (
                      <li className="parking-option-li" key={i}>
                        <span>{data.split("^^")[0]}</span>
                      </li>
                    ) : ""
                  ))}
                </ul>
              </div>
            }
            {(this.props.paymentMethods.split("|||")[1] !== (undefined || "undefined")) &&
              <div className="payment-method-main px-0">
                <h3 className="sub-head-18">{this.props.paymentMethods.split("|||")[0]}</h3>
                <ul className="payment-method-ul">
                  {this.props.paymentMethods.split("|||")[1].split("^^").map((data, i) => (
                    data !== "" ? (
                      <li className="payment-method-li" key={i}>
                        <span>{data.split("^^")[0]}</span>
                      </li>
                    ) : ""
                  ))}
                </ul>
              </div>
            }
          </div>
          <div className="col-lg-4 col-md-12 px-0 ps-lg-4 tags-wrapper">
            <h3 className="sub-head-18">{this.props.tags.split("|||")[0]}</h3>
            <ul className="near-by-localities">
              {this.props.tags.split("|||")[1] !== undefined ? <>
                {this.props.tags.split("|||")[1].split("^^").map((data, i) => (
                  data !== "" ? (
                    <li className="near-by-localities-li" key={i}>
                      <span>{data.split("^^")[0]}</span>
                    </li>
                  ) : ""
                ))}
              </> : ""}
            </ul>
          </div>
        </div>
      </div>
    );
  }
}
export default LocatorBranchInfo;
